/**
 * Procedure Categories and Procedures for MD in Human Anatomy (revised) students
 * Extracted with strict evidence from official NMC PDF
 */
export const ANATOMY_PROCEDURES = {
  "Cadaveric & Embalming Procedures": [
    "Human Body Embalming and Preservation",
    "Full Cadaveric Dissection",
    "Window Dissection of Anatomical Regions",
    "Preparation and Mounting of Museum Specimens",
    "Bone Procurement, Decalcification, and Ground Section Preparation",
  ],
  "Histological & Microtechnique Procedures": [
    "Fixative Preparation (Formalin, Bouin's Fluid)",
    "Paraffin Block Preparation & Rotary Microtome Section Cutting",
    "Haematoxylin and Eosin (H&E) Staining",
    "Frozen Section Cutting on Cryostat / Freezing Microtome",
    "Celloidin, Araldite, and Gelatin Block Preparation",
    "Microtome Knife Honing and Stropping",
  ],
  "Cytogenetic Procedures": [
    "Buccal Smear Preparation for Sex Chromatin",
    "Peripheral Blood Chromosome Preparation & Karyotyping",
    "G-Banding and C-Banding Techniques",
  ],
  "Neuroanatomical Procedures": [
    "Dissection of Brain and Spinal Cord",
  ],
};

export const ANATOMY_CATEGORIES = Object.keys(ANATOMY_PROCEDURES);

export const isMDInAnatomyDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    d.includes("human anatomy") ||
    d.includes("anatomy")
  );
};
